import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Snackbar, Alert, Fab } from "@mui/material"
import styles from "../css/Categorias.module.css"
import { useEffect, useState } from "react"
import miAxios from "../api/axios"
import { useAuth } from "../hooks/AuthProvider"
import EditIcon from '@mui/icons-material/Edit';
import Categoria from "./Categoria"
import AddIcon from '@mui/icons-material/Add';

export default function CategoriasLista(props) {
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [rows, setRows] = useState([])
    const [openCategoria, setOpenCategoria] = useState({
        id: 0,
        open: false
    })

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actRows()
    }, [])

    const actRows = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("listas/categorias-items")
            const data = response.data;
            if (data.respuesta == "S") {
                console.log(data.datos)
                setRows(data.datos)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleCerrarCategoria = () => {
        setOpenCategoria({ id: 0, open: false })
        actRows()
    }

    return <Dialog open={props.open} fullWidth>
        <Categoria open={openCategoria.open} id={openCategoria.id} cerrar={handleCerrarCategoria} />
        <Snackbar
            open={mensaje.length > 0}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setMensaje("")}
        >
            <Alert severity="error" onClose={() => setMensaje("")} variant="filled">
                {mensaje}
            </Alert>
        </Snackbar>
        <DialogTitle color="coopinfa">
            <div className={styles.add}>
                <Fab color="coopinfa" onClick={()=>{setOpenCategoria({open: true, id: 0})}}>
                    <AddIcon />
                </Fab>
            </div>
            Categorías
        </DialogTitle>
        <DialogContent>
            <div className={styles.tabla}>
                <table width={"100%"}>
                    <thead>
                        <tr className={styles.rows_head}>
                            <th style={{ width: "80px" }}>¿Editar?</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            rows.map((row) => {
                                return <tr key={row.id} className={styles.rows} style={{ borderBottom: "1px solid black" }}>
                                    <td className={styles.col_edit}>
                                        <IconButton onClick={() => { setOpenCategoria({ id: row.id, open: true }) }}>
                                            <EditIcon />
                                        </IconButton>
                                    </td>
                                    <td>{row.texto}</td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>

        </DialogContent>
        <DialogActions>
            <Button variant="contained" sx={{ minWidth: "100px" }} color="coopinfa" onClick={() => { props.cerrar() }}>Ok</Button>

        </DialogActions>
    </Dialog>
}